<!--保活的路由-->
<template>
    <div>
        <!-- <router-view v-if="isRouterAlive&&isShow&&$route.meta&&$route.meta.nokeepAlive" :globalData="globalData"></router-view>
        <keep-alive v-else>
            <router-view v-if="isRouterAlive&&isShow" :globalData="globalData"></router-view>
        </keep-alive> -->

        <!-- <keep-alive :exclude="routerviewConfig.exclude"> -->
            <router-view v-if="isRouterAlive&&isShow" :globalData="globalData" :key="key"></router-view>
        <!-- </keep-alive> -->

        <!-- <keep-alive>
            <router-view v-if="isShow&&(!$route.meta||!$route.meta.nokeepAlive)"></router-view>
        </keep-alive>
        <router-view v-if="isShow&&$route.meta&&$route.meta.nokeepAlive"></router-view>
        <router-view v-else-if="isShow&&!$route.meta"></router-view> -->
    </div>
</template>

<script>
    import routerviewConfig from "config/routerview.config.js";

    export default {
        props:{
            isShow:{//是否展示
                type:Boolean,
                default:true,
            },
            disableReload:{//是否禁用重新加载
                type:Boolean,
                default:true,
            },
            globalData:{//用于刷新路由组件
                type:Object,
                default:()=>{
                    return {};
                }
            },
        },
        provide () {
            return {
                reload: this.reload
            }
        },
        computed:{
            key(){
                return this.$route.fullPath;
            }
        },
        data(){
            return{
                routerviewConfig:routerviewConfig,
                isRouterAlive:true
            }
        },
        created(){
            // console.log("reload1111111111111：",this.disableReload);
        },
        methods: {
            reload (){
                // console.log("reload：",this.disableReload);
                if(!this.disableReload){
                    this.isRouterAlive = false;
                    this.$nextTick(function(){
                        this.isRouterAlive = true;
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>

</style>